import Swiper from 'swiper/swiper-bundle';
import 'swiper/swiper-bundle.min.css';

function sliderModule() {
	const sliders = document.querySelectorAll('.js-slider');
	sliders.forEach((slider) => {
		const numSlides = slider.querySelectorAll('.swiper-slide').length;

		const swiper = new Swiper(slider, {
			spaceBetween: 50,
			slidesPerView: 'auto',
			speed: 850,
			centeredSlides: true,
			centerInsufficientSlides: true,
			grabCursor: true,
			// loop: numSlides <= 3 ? false : true,
			// rewind: numSlides <= 3 ? true : false,
			loop: true,
			on: {
				slideChange: ({ realIndex }) =>
					(slider.querySelector('.js-slider-active-num').innerHTML = realIndex + 1),
			},
			navigation: {
				prevEl: slider.querySelector('.js-slider-go-prev'),
				nextEl: slider.querySelector('.js-slider-go-next'),
			},
		});
	});
}

sliderModule();
